// #671 — per-scribe keyboard tab order for the score sheet.
//
// Scribes don't agree on the order: some tab to the mark first, some to the
// comment first. So the per-row sequence (#668's `rowOrder` knob) is a personal
// input habit, not a fixed rule — it belongs to the human at the keyboard.
//
// Persisted in localStorage, deliberately NOT on the user/account record:
// scribe-fe is an offline-first PWA, a scribe works from one device for a
// session, and this must keep working with no network. It does not follow a
// scribe across devices.
//
// Same shape as the other scribe-local stores (manualRides.js,
// signatureStore.js): a namespaced STORAGE_KEY plus try/catch'd get/set, so a
// browser with storage disabled (private mode) degrades to the default rather
// than throwing.

import { MARK_FIRST, COMMENT_FIRST } from "../hooks/useSheetFieldNav";

const STORAGE_KEY = "scribe-fe.sheetFieldOrder";

const VALID = [MARK_FIRST, COMMENT_FIRST];

/** @returns {string} MARK_FIRST (default) or COMMENT_FIRST. */
export function getSheetFieldOrder() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    // Unset, or junk written by a future/older build — fall back to the spec
    // default rather than handing useSheetFieldNav a value it can't read.
    return VALID.includes(raw) ? raw : MARK_FIRST;
  } catch {
    return MARK_FIRST;
  }
}

/** @param {string} order - MARK_FIRST or COMMENT_FIRST; anything else is ignored. */
export function setSheetFieldOrder(order) {
  if (!VALID.includes(order)) return;
  try {
    localStorage.setItem(STORAGE_KEY, order);
  } catch {
    // Storage unavailable (private browsing) — non-fatal; the setting just
    // won't survive the reload.
  }
}
